module.exports = require("mermaid");